export default __webpack_public_path__ + "static/media/lyubo_xl.22d756df.jpg";